import { Text, TextProps } from "@mantine/core"
import { RiskScore } from "@tfg/db"
import { Missing } from "@tfg/ui"
import { useTranslation } from "react-i18next"

interface Props extends TextProps {
  risk: RiskScore
}

export const RiskScoreDisplay = ({ risk, ...rest }: Props) => {
  const { t } = useTranslation(["suppliers"])

  switch (risk) {
    case "LOW":
      return (
        <Text fw={700} c="green" {...rest}>
          {t("risk.low")}
        </Text>
      )
    case "MEDIUM":
      return (
        <Text fw={700} c="beige.9" {...rest}>
          {t("risk.medium")}
        </Text>
      )
    case "HIGH":
      return (
        <Text fw={700} c="red" {...rest}>
          {t("risk.high")}
        </Text>
      )
    default:
      return <Missing />
  }
}
